import React from 'react'
import { useOutletContext } from 'react-router-dom'
import { OutletContext } from './employer-settings-wrapper'
import { useWorkPeriodTagsQuery } from '../../queries/work-period-tags'
import WorkPeriodTagsList from '../../components/work-period-tags/list'
import SidebarContentTitle from '../../components/layout/sidebar/sidebar-content-title'
import { Box, Element, Form, Icon, Message } from 'react-bulma-components'
import { AddResourceIcon, WarningIcon } from '../../components/icons'
import WorkPeriodTagModalForm from '../../components/work-period-tags/modal-form'
import { WorkPeriodTag } from '../../api/work-period-tags'

/**
 * Component for managing employer work period tags
 * Displays a list of tags with ability to create, edit and activate/deactivate them
 */
const WorkPeriodTagsSettings: React.FC = () => {
  const { employer } = useOutletContext<OutletContext>()
  const [showInactive, setShowInactive] = React.useState(false)
  const query: { isInactive?: boolean[] | boolean } = {}
  if (showInactive) {
    query.isInactive = true
  }
  const { data: tags } = useWorkPeriodTagsQuery(query, {
    enabled: Boolean(employer),
  })
  const [currentTag, setCurrentTag] = React.useState<WorkPeriodTag | 'new' | undefined>()

  return (
    <>
      <SidebarContentTitle
        title="Catégories"
        onButtonClick={() => setCurrentTag('new')}
        addButtonLabel="Nouvelle catégorie"
        ButtonIcon={AddResourceIcon}
        buttonDataTestId="create-work-period-tag-button"
      />
      <Box>
        {showInactive && (
          <Message color="info" className="mb-4">
            <Message.Body>
              <Icon.Text>
                <Icon>
                  <WarningIcon />
                </Icon>
                Vous affichez uniquement les catégories inactives.
                <br /> Ces catégories ne sont plus utilisées dans les journées de travail. Vous
                pouvez les réactiver en les modifiant.
              </Icon.Text>
            </Message.Body>
          </Message>
        )}
        <WorkPeriodTagsList data={tags || []} onTagClick={tag => setCurrentTag(tag)} />
        <Element textAlign={'right'}>
          <Form.Field>
            <Form.Control>
              <Form.Checkbox
                checked={showInactive}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                  setShowInactive(e.target.checked)
                }
                data-test="display-inactive-work-period-tags-checkbox"
              >
                Afficher les catégories inactives
              </Form.Checkbox>
            </Form.Control>
          </Form.Field>
        </Element>
      </Box>
      <WorkPeriodTagModalForm
        isDisplayed={Boolean(currentTag)}
        setIsDisplayed={() => setCurrentTag(undefined)}
        tag={currentTag === 'new' ? undefined : currentTag}
      />
    </>
  )
}

export default WorkPeriodTagsSettings
